import { render, staticRenderFns } from "./ConfigurarAlertas.vue?vue&type=template&id=68386e2c&"
import script from "./ConfigurarAlertas.vue?vue&type=script&lang=js&"
export * from "./ConfigurarAlertas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports